import { type WButtonProps, WButton } from "@/components/button/WButton.tsx";
import * as billingAccountQuery from "@/modules/billing/billingAccountQuery.ts";
import { invalidateQueries } from "@/utils/query/invalidateQueries.ts";
import { Trans } from "@lingui/react/macro";
import { useQueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";

type RefreshStatusButtonProps = Omit<WButtonProps, "action">;

export function RefreshStatusButton({ ...props }: RefreshStatusButtonProps): ReactNode {
    const queryClient = useQueryClient();

    const refreshUserData = async () => {
        await invalidateQueries({
            queryClient,
            immediate: [billingAccountQuery.queryKey],
        });
    };
    return (
        <WButton color="primary" action={refreshUserData} {...props}>
            <Trans>Refresh status</Trans>
        </WButton>
    );
}
